/* eslint-disable react-hooks/exhaustive-deps */
import {
  useState,
  useEffect,
  createContext,
  ReactNode,
  useContext,
} from "react";
import { filterRecords, getRecords } from "../services/fetchRecords";
import { getStatus } from "../services/getStatus";
import { FilterType } from "../modules/organisms/filterWindow/renderFilters";
import { downloadTnosData } from "../services/generateData";
import { useFileUploadContext } from "./fileUploadContext";
import { SelectChangeEvent } from "@mui/material/Select";
import { getUserList } from "../services/user-management";
type RowId = string;
const getRowId = (row: any): RowId =>
  row?.chargerId ??
  row?.CHARGER_ID ??
  row?.id ??
  row?.qrUrl ??
  String(row?.qr_url ?? "");
const TableContext = createContext<any>("");

export const TableProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const token = localStorage.getItem("dm_access_token") || "";
  const userName = localStorage.getItem("dm_user_name") || "";

  const [tableData, setTableData] = useState<any>([]);
  // EVES-4279 Table Data Selection Sync
  // Author: Abhishek Bharti
  // Date: 12-02-2026
  /** Data currently displayed in the table (e.g. from useInventory). Used to sync selectedRows so selection shows in ordered/warehouse accordions. */
  const [displayedTableData, setDisplayedTableData] = useState<any>(null);
  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [selectedIds, setSelectedIds] = useState<Set<RowId>>(new Set());
  const isSelected = (id: RowId) => selectedIds.has(id);
  const toggleRow = (id: RowId, selected?: boolean) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      const shouldSelect =
        typeof selected === "boolean" ? selected : !next.has(id);
      if (shouldSelect) next.add(id);
      else next.delete(id);
      return next;
    });
  };
  const selectPage = (rowsOnPage: any[], selected: boolean) => {
    const ids = rowsOnPage.map(getRowId);
    setSelectedIds((prev) => {
      const next = new Set(prev);
      ids.forEach((id) => (selected ? next.add(id) : next.delete(id)));
      return next;
    });
  };
  const clearSelection = () => setSelectedIds(new Set());
  const pageSelectedIds = (rows: any[]) => {
    const s: Record<RowId, boolean> = {};
    rows?.forEach((r) => {
      const id = getRowId(r);
      s[id] = selectedIds.has(id);
    });
    return s;
  };
  const getSelectedIdsArray = () => Array.from(selectedIds);

  const [selectedRowsWithPage, setSelectedRowsWithPage] = useState<any>([]);
  const [selectedWareHouseRowsWithPage, setSelectedWareHouseRowsWithPage] =
    useState<any>([]);
  const [selectedWareHouseRows, setSelectedWareHouseRows] = useState<any>([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [status, setStatus] = useState("");
  const [selectedStatus, setSelectedStatus] = useState<string>("");
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loading, setLoading] = useState(false);
  const [statusList, setStatusList] = useState<any>([]);
  const [editingRow, setEditingRow] = useState(null);
  const [nonEditMode, setNonEditMode] = useState(false);
  const [editedValues, setEditedValues] = useState({});
  const [chargerValue, setChargerValue] = useState("");
  const [userValue, setUserValue] = useState(userName || "");

  const [resultCount, setResultCount] = useState(0);
  const [wareHouseRowsResultCount, setWareHouseRowsResultCount] = useState(0);
  const [showNext, setShowNext] = useState(false);
  const [showGenerate, setShowGenerate] = useState(false);
  const [generateFlag, setGenerateFlag] = useState(false);
  const [clientPage, setClientPage] = useState(0);
  const [wareHouseTablePage, setWareHouseTablePage] = useState(0);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [selectvendor, setSelectvendor] = useState();
  const [generateRowsDisplayPerPage, setGenerateRowsDisplayPerPage] =
    useState(10);
  const [clientRowsPerPage, setClientRowsPerPage] = useState(10);
  const [updateStatusWindow, setUpdateStatusWindow] = useState<boolean>(false);
  /** When true, Inventory2 owns data via v2 APIs — skip legacy v1 filterRecords effects. */
  const [skipLegacyRecordsFetch, setSkipLegacyRecordsFetch] =
    useState<boolean>(false);

  // From Filter Context
  const [checked, setChecked] = useState<string[]>([]);
  const [statusFilter, setStatusFilter] = useState<string[]>([]);
  const [selectedField, setSelectedField] = useState<FilterType>("vendor");
  const [openFilter, setOpenFilter] = useState<any>(false);
  const [vendorFilterList, setVendorFilterList] = useState<any>([]);
  const [filterModel, setFilterModel] = useState<string>("");
  const [filterOcpp, setFilterOcpp] = useState<string>("");
  const [connectors, setConnectors] = useState<any>("");
  const [connectorType, setConnectorType] = useState<string[]>([]);
  const [qrFlag, setQrFlag] = useState<string>("");
  const [filterStatus, setFilterStatus] = useState<string[]>([]);
  const [filterTenant, setFilterTenant] = useState<string>("");
  const [applyFilter, setApplyFilter] = useState(false);
  const [accordian, setAccordian] = useState(1);
  const [vendors, setVendors] = useState([]);
  const [models, setModels] = useState([]);
  const [clientFormData, setClientFormData] = useState({
    clientOrderNum: "",
    clientName: "",
    address: "",
    notes: "",
  });
  const [dataList, setDataList] = useState<any>([]);
  const initialPagination = {
    page: 0,
    rowsPerPage: 10,
    count: 0,
  };
  const [pagination, setPagination] = useState(initialPagination);
  const [paginationBottom, setPaginationBottom] = useState(false);
  const [selectedClients, setSelectedClients] = useState<any>([]); // Updated state to hold client objects
  const [clientinfo, setClientinfo] = useState([]);
  const [editMode, setEditMode] = useState<any>(false);
  const [applyRole, setApplyRole] = useState<any>();
  const [applyEmail, setApplyEmail] = useState<any>();

  const uniqueEmails = Array.from(
    new Set(dataList?.map((user: any) => user.emailAddress))
  );
  const uniqueRoles = Array.from(
    new Set(dataList?.flatMap((user: any) => user.role))
  );
  const handleChangeClient = (
    event: SelectChangeEvent<typeof selectedClients>
  ) => {
    const {
      target: { value },
    } = event;
    setSelectedClients(value);
  };
  const renderRecords = () => {
    getRecords({
      page: page ? page + 1 : 1,
      pageSize: rowsPerPage ? rowsPerPage : 10,
    })
      .then((res: any) => {
        setLoading(false);
        updatedTableData(res?.data?.items);
        setResultCount(res?.data?.resultCount);
      })
      .catch((error: any) => {
        setLoading(false);
        setFailedWindow({
          status: true,
          message: error?.Message,
        });
      });
  };

  const [wareHouseStatusRows, setWareHouseStatusRows] = useState<any>([]);

  const { successWindow, setSuccessWindow, failedWindow, setFailedWindow } =
    useFileUploadContext();

  const handleVendor = (vendorList: Array<any>) => {
    setVendorFilterList(vendorList);
  };

  const handleModel = (model: string) => {
    setFilterModel(model);
  };

  const handleOcpp = (ocpp: string) => {
    setFilterOcpp(ocpp);
  };

  const handleConnectors = (connectors: string) => {
    setConnectors(connectors);
  };

  const handleQrFlag = (flag: string) => {
    setQrFlag(flag);
  };

  const handleConnectorType = (type: string[]) => {
    setConnectorType(type);
  };

  const handleFilterStatus = (status: string[]) => {
    setFilterStatus(status);
  };

  const handleTenant = (tenant: string) => {
    setFilterTenant(tenant);
  };

  const getData = async () => {
    setLoading(true);
    const response: any = await getUserList({
      PageNumber: pagination.page + 1,
      PageSize: pagination.rowsPerPage,
      //Author: Vamshi
      //https://3insys.atlassian.net/browse/EVES-1834
      //Searching in the user management
      UserName: userValue || "",
      EmailAddress: applyEmail || "",
      FirstName: "",
      Role: applyRole || "",
    });
    if (response) {
      setLoading(false);
    }

    setDataList(response?.data?.users);

    setPagination({
      ...pagination,
      count: response?.data?.totalRecords,
    });
  };
  useEffect(() => {
    getData();
  }, [
    pagination.page,
    pagination.rowsPerPage,
    applyRole,
    applyEmail,
    userValue,
  ]);
  useEffect(() => {
    getData();
  }, []);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableData?.length) : 0;

  //   return filteredTableData?.slice(
  //     page * rowsPerPage,
  //     page * rowsPerPage + rowsPerPage
  //   );
  // }, [page, rowsPerPage, tableData, status,chargerValue]);

  const generateButton = () => {
    downloadTnosData(
      {
        clientFormData,
        selectedWareHouseRows,
        setClientFormData,
        setSelectedRows,
        setWareHouseStatusRows,
        selectedWareHouseRowsWithPage,
        setSelectedWareHouseRowsWithPage,
      },
      successWindow,
      setSuccessWindow,
      failedWindow,
      setFailedWindow,
      updatedTableData,
      setResultCount
    );
    setGenerateFlag(false);
    setSelectedRows([]);
    setSelectedWareHouseRows([]);
    setSelectedWareHouseRowsWithPage([]);
    setShowGenerate(false);
  };

  const arrowBackButton = () => {
    if (showGenerate) {
      setShowNext(true);
      setShowGenerate(false);
    }

    if (showNext) {
      setGenerateFlag(false);
      setSelectedRows([]);
      setShowNext(false);
    }
  };

  const arrowBackButtonHandler = () => {
    if (showGenerate) {
      setShowNext(true);
      setShowGenerate(false);
    }

    if (showNext) {
      setGenerateFlag(false);
      setSelectedRows([]);
      setShowNext(false);

      if (!showGenerate) {
        renderRecords();
      }
    }
  };
  const nextButton = () => {
    setShowNext(false);
    setShowGenerate(() => true);
  };

  const updatedTableData = (newData: any) => {
    if (!newData) {
      return;
    }

    const updatedData = [...newData];
    setTableData((prevState: any) => (prevState = updatedData));
  };

  const updatedWareHouseData = (newData: any) => {
    if (!newData) {
      return;
    }
    const updatedData = [...newData];
    setWareHouseStatusRows((prevState: any) => (prevState = updatedData));
  };

  useEffect(() => {
    if (token && !skipLegacyRecordsFetch) {
      setLoading(true);
      const payload = {
        page: page ? page : 1,
        rowsPerPage: rowsPerPage ? rowsPerPage : 10,
        chargers: chargerValue,
        vendors: checked,
        filterModel: filterModel,
        filterOcpp: filterOcpp,
        connectorNo: connectors,
        connectorType: connectorType,
        qrCode: qrFlag === "Yes" ? true : qrFlag === "No" ? false : "",
        status: filterStatus,
        tenant: filterTenant,
      };
      filterRecords(payload)
        .then((res: any) => {
          setLoading(false);

          if (res?.status === 400) {
            setFailedWindow({
              status: true,
              message: "Could not fetch Records",
            });
          }

          if (res?.returnCode === 200) {
            updatedTableData(res?.data?.items);
            setResultCount(res?.data?.resultCount);
          }
        })
        .catch((error: any) => {
          setLoading(false);
          setFailedWindow({
            status: true,
            message: error?.Message,
          });
        });
    }
  }, [page, rowsPerPage, editingRow, token, skipLegacyRecordsFetch]);

  const closeButton = () => {
    setGenerateFlag(false);
    setSelectedRows([]);
    setSelectedWareHouseRows([]);
    setSelectedWareHouseRowsWithPage([]);
    setShowGenerate(false);
    setShowNext(false);
    renderRecords();
  };

  useEffect(() => {
    if (token) {
      getStatus(setStatusList, selectedStatus, setSelectedStatus);
    }
  }, [token]);

  useEffect(() => {
    if (token && !skipLegacyRecordsFetch) {
      setLoading(true);

      const payloadCharger = {
        page: wareHouseTablePage ? wareHouseTablePage : 1,
        rowsPerPage: generateRowsDisplayPerPage
          ? generateRowsDisplayPerPage
          : 10,
        chargers: chargerValue,
        vendors: [],
        filterModel: "",
        filterOcpp: "",
        connectorNo: "",
        connectorType: "",
        qrCode: "",
        tenant: "",
        status: "InWareHouse",
      };

      if (showNext && chargerValue === "" && !applyFilter) {
        filterRecords(payloadCharger)
          .then((res: any) => {
            setLoading(false);

            if (res?.status === 400) {
              setFailedWindow({
                status: true,
                message: "Could not fetch records",
              });
            }

            updatedWareHouseData(res?.data?.items);
            // setWareHouseStatusRows(res?.data?.items);
            setWareHouseRowsResultCount(res?.data?.resultCount);
            setWareHouseTablePage(res?.data?.pageNumber);
            setGenerateRowsDisplayPerPage(res?.data?.pageSize);
            setGenerateRowsDisplayPerPage(res?.data?.pageSize);
            setWareHouseStatusRows([]);
          })
          .catch((error: any) => {
            setLoading(false);
            setFailedWindow({
              status: true,
              message: error?.Message,
            });
          });
      }

      if (!showNext) {
        setWareHouseTablePage(0);
        setWareHouseRowsResultCount(0);
        setGenerateRowsDisplayPerPage(10);
      }

      if (!showNext && !showGenerate) {
        setSelectedWareHouseRows([]);
        setSelectedWareHouseRowsWithPage([]);
      }
    }
  }, [showNext, wareHouseTablePage, chargerValue, token, skipLegacyRecordsFetch]);

  // EVES-4279 Table Data Selection Sync
  // Author: Abhishek Bharti
  // Date: 12-02-2026
  useEffect(() => {
    const sourceData = displayedTableData ?? tableData;
    const currentPageRows = sourceData ?? [];
    const currentSelected = currentPageRows.filter((r: any) =>
      selectedIds.has(getRowId(r))
    );
    setSelectedRows(currentSelected);
  }, [displayedTableData, tableData, selectedIds]);

  useEffect(() => {
    if (token && !skipLegacyRecordsFetch) {
      if (chargerValue !== "" && showNext) {
        const payload = {
          page: wareHouseTablePage ? wareHouseTablePage : 1,
          rowsPerPage: generateRowsDisplayPerPage
            ? generateRowsDisplayPerPage
            : 10,
          chargers: chargerValue,
          vendors: checked,
          filterModel: filterModel,
          filterOcpp: filterOcpp,
          connectorNo: connectors,
          connectorType: connectorType,
          qrCode: qrFlag === "Yes" ? true : qrFlag === "No" ? false : "",
          status: ["InWareHouse"],
          tenant: filterTenant,
        };

        filterRecords(payload)
          ?.then((res: any) => {
            setLoading(false);
            updatedWareHouseData(res?.data?.items);
            setWareHouseTablePage(res?.data?.pageNumber);
            setGenerateRowsDisplayPerPage(res?.data?.pageSize);
            setWareHouseRowsResultCount(res?.data?.resultCount);
            setSelectedWareHouseRows([]);
            setSelectedWareHouseRowsWithPage([]);
            // if (!chargerValue) {
            //   setResultCount(res?.data?.resultCount);
            // }
          })
          .catch((error: any) => {
            setLoading(false);
            setFailedWindow({
              status: true,
              message: error?.Message,
            });
          });
      }

      if (chargerValue !== "" && !showNext) {
        const payload = {
          page: page ? (chargerValue !== "" ? 1 : page) : 1,
          rowsPerPage: chargerValue !== "" ? 10 : rowsPerPage,
          chargers: chargerValue,
          vendors: checked,
          filterModel: filterModel,
          filterOcpp: filterOcpp,
          connectorNo: connectors,
          connectorType: connectorType,
          qrCode: qrFlag === "Yes" ? true : qrFlag === "No" ? false : "",
          status: filterStatus,
          tenant: filterTenant,
        };

        filterRecords(payload)
          ?.then((res: any) => {
            setLoading(false);
            updatedTableData(res?.data?.items);
            setPage(res?.data?.pageNumber);
            setRowsPerPage(res?.data?.pageSize);
            setResultCount(res?.data?.resultCount);
            setSelectedRows([]);
            // if (!chargerValue) {
            //   setResultCount(res?.data?.resultCount);
            // }
          })
          .catch((error: any) => {
            setLoading(false);
            setFailedWindow({
              status: true,
              message: error?.Message,
            });
          });
      }

      if (chargerValue === "" && showNext) {
        const payload = {
          page: wareHouseTablePage ? wareHouseTablePage : 1,
          rowsPerPage: generateRowsDisplayPerPage
            ? generateRowsDisplayPerPage
            : 10,
          chargers: chargerValue,
          vendors: checked,
          filterModel: filterModel,
          filterOcpp: filterOcpp,
          connectorNo: connectors,
          connectorType: connectorType,
          qrCode: qrFlag === "Yes" ? true : qrFlag === "No" ? false : "",
          status: ["InWareHouse"],
          tenant: filterTenant,
        };

        filterRecords(payload)
          ?.then((res: any) => {
            setLoading(false);
            updatedWareHouseData(res?.data?.items);
            // setWareHouseTablePage(res?.data?.pageNumber);
            setGenerateRowsDisplayPerPage(res?.data?.pageSize);
            setWareHouseRowsResultCount(res?.data?.resultCount);
            // setSelectedWareHouseRows([]);
            // if (!chargerValue) {
            //   setResultCount(res?.data?.resultCount);
            // }
          })
          .catch((error: any) => {
            setLoading(false);
            setFailedWindow({
              status: true,
              message: error?.Message,
            });
          });
      } else if (chargerValue === "" && !showNext) {
        renderRecords();
      }
    }
  }, [chargerValue, wareHouseTablePage, token, skipLegacyRecordsFetch]);

  const resetFilters = () => {
    setChecked([]);
    handleModel("");
    handleOcpp("");
    handleConnectors("");
    handleConnectorType([]);
    handleQrFlag("");
    handleFilterStatus([]);
    handleTenant("");
    renderRecords();
    setUpdateStatus(!updateStatus);
  };

  const handleClickFilter = () => {
    setOpenFilter(true);
    setApplyFilter(false);
  };

  return (
    <TableContext.Provider
      value={{
        tableData,
        updatedTableData,
        selectedRows,
        setSelectedRows,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
        status,
        setStatus,
        statusList,
        // visibleRows,
        emptyRows,
        editingRow,
        setEditingRow,
        nonEditMode,
        setNonEditMode,
        editedValues,
        setEditedValues,
        chargerValue,
        setChargerValue,
        resultCount,
        showNext,
        setShowNext,
        showGenerate,
        nextButton,
        generateButton,
        generateFlag,
        setGenerateFlag,
        arrowBackButton,
        closeButton,
        selectedStatus,
        setSelectedStatus,
        clientPage,
        setClientPage,
        generateRowsDisplayPerPage,
        setGenerateRowsDisplayPerPage,
        wareHouseStatusRows,
        setWareHouseStatusRows,
        wareHouseTablePage,
        setWareHouseTablePage,
        renderRecords,
        clientRowsPerPage,
        setClientRowsPerPage,

        //FILTERS -
        checked,
        setChecked,
        statusFilter,
        setStatusFilter,
        selectedField,
        setSelectedField,
        openFilter,
        setOpenFilter,
        vendorFilterList,
        handleVendor,
        filterModel,
        handleModel,
        filterOcpp,
        handleOcpp,
        connectors,
        handleConnectors,
        connectorType,
        handleConnectorType,
        qrFlag,
        handleQrFlag,
        filterStatus,
        handleFilterStatus,
        filterTenant,
        handleTenant,
        applyFilter,
        setApplyFilter,
        handleClickFilter,
        dataList,
        //RESET Filters
        resetFilters,
        //generate Client Onos
        clientFormData,
        setClientFormData,
        paginationBottom,
        setPaginationBottom,
        wareHouseRowsResultCount,
        setWareHouseRowsResultCount,
        selectedWareHouseRows,
        setSelectedWareHouseRows,
        updatedWareHouseData,
        arrowBackButtonHandler,
        updateStatusWindow,
        setUpdateStatusWindow,

        // For multiple selection across pages
        selectedRowsWithPage,
        setSelectedRowsWithPage,
        selectedWareHouseRowsWithPage,
        setSelectedWareHouseRowsWithPage,
        setFailedWindow,
        selectedClients,
        handleChangeClient,
        clientinfo,
        setClientinfo,
        updateStatus,
        setUpdateStatus,
        accordian,
        setAccordian,
        selectvendor,
        setSelectvendor,
        vendors,
        setVendors,
        models,
        setModels,
        setEditMode,
        editMode,
        pagination,
        setPagination,
        setUserValue,
        userValue, //EVES-1834
        getData,
        applyRole,
        setApplyRole,
        applyEmail,
        setApplyEmail,
        uniqueEmails,
        uniqueRoles,
        selectedIds,
        isSelected,
        toggleRow,
        selectPage,
        clearSelection,
        getRowId,
        pageSelectedIds,
        getSelectedIdsArray,
        setDisplayedTableData,
        skipLegacyRecordsFetch,
        setSkipLegacyRecordsFetch,
      }}
    >
      {children}
    </TableContext.Provider>
  );
};

export const useTableContext = (): any => {
  const context = useContext(TableContext);
  if (!context) {
    throw new Error("useTableContext must be used within a TableProvider");
  }
  return context;
};
